"use client";

import React from "react";
import styles from "./SimpleLoader.module.scss";

interface SimpleLoaderProps {
  isLoading?: boolean;
  className?: string;
  size?: "small" | "medium" | "large";
  variant?: "spinner" | "dots" | "pulse";
  overlay?: boolean;
  text?: string;
}

const SimpleLoader: React.FC<SimpleLoaderProps> = ({
  isLoading = true,
  className = "",
  size = "small",
  variant = "spinner",
  overlay = false,
  text = "Loading...",
}) => {
  if (!isLoading) return null;

  const loaderContent = (
    <div className={`${styles.loaderContainer} ${className}`}>
      {variant === "spinner" && (
        <div className={`${styles.spinner} ${styles[size]}`}>
          <div className={styles.spinnerInner}></div>
        </div>
      )}
      
      {variant === "dots" && (
        <div className={`${styles.dots} ${styles[size]}`}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
      )}
      
      {variant === "pulse" && (
        <div className={`${styles.pulse} ${styles[size]}`}></div>
      )}
      
      {text && <div className={styles.loaderText}>{text}</div>}
    </div>
  );

  if (overlay) {
    return (
      <div className={styles.overlay}>
        {loaderContent}
      </div>
    );
  }

  return loaderContent;
};

export default SimpleLoader;

